import Vuex from "vuex"
import auth from "./modules/auth";
import sesiunetaxe  from "./modules/sesiunetaxe";

export default new Vuex.Store({
    modules: {
        auth,
        sesiunetaxe
    },
});
